import React, { useState, useEffect } from 'react'
import { Panel, Row, Col } from 'rsuite'
import InputForm from '../../../components/forms/input/InputForm'
import InputRadioForm from '../../../components/forms/input/InputRadioForm'
import CustomAlertMessage from '../../CustomAlertMessage'

export default function EditFormListChoiceWidget({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ignoreDesc,
  setLoading = () => {},
  ...props
}) {
  const [schema, setSchema] = useState(_schema)

  const displayCompt = (data, tabRight) => {
    // console.log('data : ', data)
    return (
      <>
        {data?.map((item) => {
          let inputObj

          if (item.type && item.type != 'LABEL') {
            if (item.type == 'RADIO') {
              inputObj = (
                <InputRadioForm
                  schema={item}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  //postWidth={50}
                />
              )
            }
          } else if (item.resultType) {
            inputObj = (
              <>
                <InputForm
                  schema={item}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  isInputNumber={item.resultType == '1'}
                />
                {item.childs && displayCompt(item.childs, true)}
              </>
            )
          } else {
            inputObj = (
              <div style={{ marginTop: 10 }}>
                {item.label}
                {item.childs && displayCompt(item.childs, true)}
              </div>
            )
          }

          //console.log('inputObj : ', inputObj)
          return (
            <Row style={{ marginLeft: tabRight ? 20 : undefined, marginBottom: 10 }}>
              <Col xs={24} sm={24} md={24} lg={24}>
                {inputObj}
              </Col>
            </Row>
          )
        })}
      </>
    )
  }

  return (
    <Panel
      header={props.header}
      collapsible={props.collapsible}
      defaultExpanded={props.defaultExpanded}
      bordered={props.bordered}
      style={{ marginBottom: 20 }}
    >
      <Row style={{ marginTop: -10 }}>
        {!ignoreDesc && schema.description && (
          <Col style={{ marginBottom: 10 }}>
            <CustomAlertMessage contents={schema.description} />
          </Col>
        )}
      </Row>

      {schema.objects && displayCompt(schema.objects, false)}
    </Panel>
  )
}
